import { render } from "./FocusRing.vue?vue&type=template&id=65082447"
import script from "./FocusRing.vue?vue&type=script&lang=js"
export * from "./FocusRing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__